import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import LoadingSpinner from './components/common/LoadingSpinner';
import ErrorBoundary from './components/common/ErrorBoundary';
import useScrollToTop from './hooks/useScrollToTop';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('./pages/HomePage'));
const PlowDayPage = lazy(() => import('./pages/PlowDayPage'));
const SummerShowPage = lazy(() => import('./pages/SummerShowPage'));
const HarvestFestivalPage = lazy(() => import('./pages/HarvestFestivalPage'));
const OliverPage = lazy(() => import('./pages/OliverPage'));
const DonatePage = lazy(() => import('./pages/DonatePage'));
const PastEventsPage = lazy(() => import('./pages/PastEventsPage'));

function App() {
  useScrollToTop();

  return (
    <ErrorBoundary>
      <Helmet>
        <html lang="en" />
      </Helmet>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/plow-day" element={<PlowDayPage />} />
              <Route path="/summer-show" element={<SummerShowPage />} />
              <Route path="/harvest-festival" element={<HarvestFestivalPage />} />
              <Route path="/oliver" element={<OliverPage />} />
              <Route path="/past-events" element={<PastEventsPage />} />
              <Route path="/donate" element={<DonatePage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;

